module.exports = __webpack_public_path__ + "static/butchi2-79b7b72e073ceb18f8748c34f4ee7052.jpg";